// extracted by mini-css-extract-plugin
export var container = "styles-module--container--UcgL4";
export var copyright = "styles-module--copyright--BouPY";
export var desktop = "styles-module--desktop--CGFJI";
export var fadeIn = "styles-module--fadeIn--XgD2I";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--Xmf6C";
export var footer = "styles-module--footer--QY29U";
export var horizontalDivider = "styles-module--horizontalDivider--VeK2W";
export var left = "styles-module--left--1kHBe";
export var mobile = "styles-module--mobile--oSBBS";
export var navigation = "styles-module--navigation--kuBDl";
export var right = "styles-module--right--Ck5qD";
export var scaleUp = "styles-module--scaleUp--QMsXf";
export var slideIn = "styles-module--slideIn--Fp409";
export var social = "styles-module--social--PP63x";
export var verticalDivider = "styles-module--verticalDivider--XKO1v";